module.exports = __webpack_public_path__ + "static/media/logo_top.695bf5d3.png";